import React from "react"

import MetaTag from "components/Common/Meta-tag"
import VehicleDetails from "./Details"

function VehicleDetail() {
  return (
    <>
      <MetaTag title={"About Vehicle"} />
      <VehicleDetails />
    </>
  )
}

export default VehicleDetail
